<template>
  <SystemError v-if="errorState.isError" />
  <v-app v-else id="lg">
    <v-navigation-drawer permanent :rail="navExpand" width="265" @mouseover="navMouse = false" @mouseleave="navMouse = true">
      <Menu :billinggroup-id="selectedBillinggroupId"></Menu>
    </v-navigation-drawer>
    <Header>
      <template #menudrawer>
        <v-app-bar-nav-icon id="drawer" @click.stop="navBtn = !navBtn"></v-app-bar-nav-icon>
      </template>
      <template v-if="showBillinggroups" #billinggroup>
        <v-dialog v-model="showDialog" scrollable max-width="900px" theme="light">
          <template #activator="{ props }">
            <v-btn id="billinggrouplist" variant="elevated" v-bind="props" color="indigo">契約グループ一覧</v-btn>
          </template>
            <v-card id="dialog">
              <v-card-title>
                <v-row>
                  <v-col class="d-flex align-center" cols="12" sm="6" md="6">契約グループ一覧</v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-spacer></v-spacer>
                    <v-text-field
                      id="billinggroupSearch"
                      v-model="billinggroupSearch"
                      :append-inner-icon="mdiMagnify"
                      label="絞り込み検索"
                      hide-details
                      double-line
                      variant="underlined"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card-title>
              <v-data-table
                :headers="billinggroupHeaders"
                :items="session.billinggroup_list"
                :items-per-page="10"
                :items-per-page-options="perPageOptions"
                :items-per-page-text="perPageText"
                :search="billinggroupSearch"
                class="elevation-1"
                density="compact"
              >
                <template #[`item.billing`]="{ item }">
                  <v-btn name="toThisBillingsList" color="primary" size="small" @click="selectGroup(item.billinggroup_id)"> 表示 </v-btn>
                </template>
              </v-data-table>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn id="closeDialog" @click="showDialog = false">閉じる</v-btn>
              </v-card-actions>
            </v-card>
        </v-dialog>
      </template>
      <v-icon :icon="mdiAccountCircle"></v-icon>
      <template #logininfo>
        <div>
          最終アクセス日時
          <br />
          <span id="lastAccessAt">{{ session.last_access_at }}</span>
        </div>
        <div class="text-center">
          <v-menu>
            <template #activator="{ props }">
              <v-btn id="usermenu" v-bind="props" :variant="true && 'flat'" color="indigo" style="text-transform: none">
                <v-avatar color="indigo">
                  <v-icon :icon="mdiAccountCircle" size="x-large"></v-icon>
                </v-avatar>
                <span id="userId">{{ session.mypage_user_id }}</span>
              </v-btn>
            </template>
            <v-list density="compact" theme="light">
              <v-list-item id="toPasswordEdit" :to="{ name: 'PasswordEdit' }">
                <template #prepend>
                  <v-icon :icon="mdiAccountEdit"></v-icon>
                </template>
                <v-list-item-title>パスワード変更</v-list-item-title>
              </v-list-item>
              <v-list-item id="logout" @click="doLogout">
                <template #prepend>
                  <v-icon :icon="mdiLogout"></v-icon>
                </template>
                <v-list-item-title>ログアウト</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </template>
    </Header>
    <router-view v-if="isReady" :key="toggleToRefreshChild" />
    <Footer />
  </v-app>
</template>

<script>
import Menu from '@/components/Menu';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import SystemError from '@/views/SystemError';
import Api from '@/constants/api';
import UserRole from '@/constants/userrole';
import Pagination from '@/constants/pagination';
import { mdiMagnify, mdiAccountCircle, mdiAccountEdit, mdiLogout } from '@mdi/js';
import { useIsErrorStore } from '../stores/isError';

export default {
  components: {
    Menu,
    Header,
    Footer,
    SystemError,
  },
  beforeRouteUpdate(to, from, next) {
    this.errorState.reset;
    this.showDialog = false;
    next();
  },
  setup() {
    const errorState = useIsErrorStore();
    return {
      errorState,
    };
  },
  data: () => ({
    navBtn: true,
    navMouse: true,
    showDialog: false,
    showBillinggroups: false,
    isReady: false,
    toggleToRefreshChild: false,
    session: {},
    billinggroupHeaders: [
      { title: '契約グループID', key: 'billinggroup_id', sortable: true },
      { title: '契約グループ名', key: 'billinggroup_name', sortable: true },
      { title: '契約情報', key: 'billing', sortable: false, filterable: false },
    ],
    billinggroupSearch: '',
    selectedBillinggroupId: '',
    mdiMagnify,
    mdiAccountCircle,
    mdiAccountEdit,
    mdiLogout,
    accountMenu: [
      { text: 'パスワード変更', icon: mdiAccountEdit },
      { text: 'ログアウト', icon: mdiLogout },
    ],
  }),
  computed: {
    navExpand() {
      return this.navBtn === true ? this.navMouse : this.navBtn;
    },
    perPageText() {
      return Pagination.ITEMS_PER_PAGE_TEXT;
    },
    perPageOptions() {
      return Pagination.PER_PAGE_OPTIONS;
    },
  },
  created: async function () {
    await this.createBillinggroup();
    this.isReady = true;
  },
  methods: {
    doLogout: async function () {
      const accessToken = this.$cookies.get('access_token');
      const response = await this.axios.post(Api.PATH_LOGOUT, {
        access_token: accessToken,
      });
      console.log(response);
      this.$cookies.remove('access_token');
      this.$router.push({ name: 'Login' });
    },
    selectGroup: async function (billinggroupId) {
      const response = await this.axios.patch(Api.PATH_SESSION, {
        billinggroup_id: billinggroupId,
      });
      if (response.data.status != Api.STATUS_SUCCESS) {
        throw 'API_PATCH_SESSION failed. status=' + response.data.status;
      }
      const sessionResponse = await this.axios.get(Api.PATH_SESSION);
      if (sessionResponse.data.status != Api.STATUS_SUCCESS) {
        this.$cookies.remove('access_token');
        this.$router.push({ name: 'Login' });
        return;
      }
      this.session.role_id = sessionResponse.data.session.role_id;
      this.showDialog = false;
      let target;
      if (this.session.role_id == UserRole.BILLINGUSER) {
        target = 'InvoicesList';
      } else {
        target = 'BillingsList';
      }
      this.selectedBillinggroupId = billinggroupId;
      if (this.$route.path != this.$router.resolve({ name: target }).href) {
        this.$router.push({ name: target });
      } else {
        this.toggleToRefreshChild = !this.toggleToRefreshChild;
      }
    },
    createBillinggroup: async function () {
      const sessionResponse = await this.axios.get(Api.PATH_SESSION);
      if (sessionResponse.data.status != Api.STATUS_SUCCESS) {
        this.$cookies.remove('access_token');
        this.$router.push({ name: 'Login' });
        return;
      }
      this.session = sessionResponse.data.session;

      const groupResponse = await this.axios.get(Api.PATH_GROUP);
      if (groupResponse.data.status != Api.STATUS_SUCCESS) {
        throw 'API_GROUP failed. status=' + groupResponse.data.status;
      }
      this.session.billinggroup_list = groupResponse.data.billinggroup_list;

      if (!this.session.billinggroup_list || this.session.billinggroup_list.length <= 0) {
        console.log('billinggroup_list is invalid.');
        return;
      }

      if (!this.session.billinggroup_id) {
        const response = await this.axios.patch(Api.PATH_SESSION, {
          billinggroup_id: this.session.billinggroup_list[0].billinggroup_id,
        });
        if (response.data.status != Api.STATUS_SUCCESS) {
          throw 'API_PATCH_SESSION failed. status=' + response.data.status;
        }
      }

      if (this.session.billinggroup_list.length > 1) {
        this.showBillinggroups = true;
      }
    },
  },
};
</script>

<style scoped>
.v-data-table :deep(th),
.v-data-table :deep(.v-data-table-footer) {
  font-size: 12px !important;
}
.v-data-table :deep(td) {
  font-size: 14px !important;
}
</style>
